module.exports = __webpack_public_path__ + "media/images/financial-plans/onboarding-introplan-graphic-182879865ad8bdf50bdbe8c90bbee33f.svg";